import { handleActions } from 'redux-actions'
import { setLocalItem, getLocalItem } from '../../utils'
import { UserModel } from '../../model/user.model'
import { Set_User_Info, Delete_User_Info } from '../actions/user'

export const Local_User_Key = 'l_u_k'

/** 用户信息初始化 */
const initUserInfo = (): UserModel | null => {
    return getLocalItem(Local_User_Key)
}

const userReducer = handleActions(
    {
        /** 存储用户信息 */
        [Set_User_Info]: (state, { payload }) => {
            if (!payload) return null
            setLocalItem(Local_User_Key, payload)
            return payload
        },
        /** 删除用户信息 */
        [Delete_User_Info]: (state, { payload }) => {
            localStorage.removeItem(Local_User_Key)
            return null
        },
    },
    initUserInfo()
)

export default userReducer
